import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import SnackBar from '../FormFields/Snackbar';
import { H3, Body3 } from '../../themes/typography';
import {
    FacebookIcon,
    LinkedinIcon,
    CopyIcon,
    WhatsappIcon,
    Xtwitter
} from '../../icons/FontAwesomeIcon';
import { FacebookShareButton, LinkedinShareButton } from 'react-share';
import '../../styles/components/EventSharePopup.css';

export default function EventSharePopup({ open, onClose, shareEventName }) {
    const [openSnack, setOpenSnack] = useState(false);
    const websiteUrl = 'https://www.shmooz.in';

    const openFacebookShareDialog = () => {
        const shareEventNameFacebook = `Exciting Event: ${shareEventName}`;
        const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${websiteUrl}}`;

        window.open(facebookShareUrl, '_blank', 'width=1200,height=1200');
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <div className="share-model-container">
                <div className="sharing-title-and-close-button-section">
                    <H3 color="#F8A21E">Share with friends</H3>
                    <ModalClose
                        onClick={onClose}
                        sx={{
                            position: 'static',
                            '& .css-1r2bn3-JoySvgIcon-root': {
                                color: 'white',
                                transition: 'all 0.1s ease-in-out'
                            },
                            '& .css-1r2bn3-JoySvgIcon-root:hover': {
                                color: '#26C1E8'
                            },
                            '&:hover': {
                                backgroundColor: 'transparent'
                            }
                        }}
                    />
                </div>

                <div className="share-model-content-section">
                    {/* Copy Link */}
                    <div
                        className="social-icons-link"
                        onClick={() => {
                            navigator.clipboard.writeText(websiteUrl);
                            setOpenSnack(true);
                        }}
                    >
                        <CopyIcon style={{ color: '#26C1E8', fontSize: '2.5rem' }} />
                        <Body3>Copy Link</Body3>
                    </div>

                    {/* WhatsApp */}
                    <div className="social-icons-link">
                        <WhatsappIcon style={{ color: '#26C1E8', fontSize: '2.5rem' }} />
                        <Link
                            to={`https://api.whatsapp.com/send?text=Hey%2C%20check%20out%20this%20event%21%0A%0A*${encodeURIComponent(shareEventName)}*%0A${encodeURIComponent(websiteUrl)}%0A%0ADiscovered%20on%20Shmooz.in%20`}
                        >
                            <Body3>Whatsapp</Body3>
                        </Link>
                    </div>

                    {/* X (Twitter) */}
                    <div className="social-icons-link">
                        <Xtwitter style={{ color: '#26C1E8', fontSize: '2.5rem' }} />
                        <Link
                            to={`https://twitter.com/intent/tweet?text=Hey%20Check%20out%20this%20event%21%0A%0A${encodeURIComponent(shareEventName)}%0A${encodeURIComponent(websiteUrl)}%0A%0ADiscovered%20on%20Shmooz.in`}
                            target="_blank"
                        >
                            <Body3>Twitter</Body3>
                        </Link>
                    </div>

                    {/* LinkedIn */}
                    <div className="social-icons-link">
                        <LinkedinShareButton url={websiteUrl}>
                            <LinkedinIcon style={{ color: '#26C1E8', fontSize: '2.5rem' }} />
                        </LinkedinShareButton>
                        <Body3>Linkedin</Body3>
                    </div>

                    {/* Facebook */}
                    <div className="social-icons-link" onClick={openFacebookShareDialog}>
                        <FacebookShareButton url={websiteUrl}>
                            <FacebookIcon style={{ color: '#26C1E8', fontSize: '2.5rem' }} />
                        </FacebookShareButton>
                        <Body3>Facebook</Body3>
                    </div>
                </div>

                <SnackBar openSnack={openSnack} setOpenSnack={setOpenSnack} />
            </div>
        </Modal>
    );
}
